/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { colors, mixins } from '@blend/consumer-components';

const styles = StyleSheet.create({
  PopoverListButton: {
    borderRadius: 4,
    color: colors.catalyst,
    display: 'flex',
    padding: 0,
    border: 'none',
    boxShadow: 'none',
    width: '100%',
    background: 'none',
    ...mixins.transition('background-color', 0.2),
    ':hover': {
      backgroundColor: colors.catalystLight03,
    },
  },

  label: {
    ...mixins.paddingHorizontal(10),
    ...mixins.paddingVertical(15),
  },
});

export namespace PopoverListButton {
  export interface Props {
    name: string;
    display: string;
    onClick: (e: React.SyntheticEvent) => void;
  }
}

export const PopoverListButton: React.FC<PopoverListButton.Props> = ({ name, display, onClick }) => {
  return (
    <button className={css(styles.PopoverListButton)} onClick={onClick} data-it={`PopoverListButton-${name}`}>
      <span id="it-PopoverListButton-label" className={css(styles.label)}>
        {display}
      </span>
    </button>
  );
};
